<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-icon icon="loyalty" @click="showMasterMetaData()" size="small"
              >M</vs-icon
            >
            <h3>View Company</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
        
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />
        <div class="vx-row mb-6" v-if="accountDescription.is_sole_trader">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="showAccountMetaData('is_sole_trader', 'Is Sole Trader')"
                size="small"
                >M</vs-icon
              >
              Is Sole Trader:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.is_sole_trader }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.source">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="showAccountMetaData('source', 'Source')"
                size="small"
                >M</vs-icon
              >
              Source:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.source }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.company_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="showAccountMetaData('company_name', 'Company Name')"
                size="small"
                >M</vs-icon
              >
              Company Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.company_name }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.actual_account_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="showAccountMetaData('actual_account_name', 'Actual Account Name')"
                size="small"
                >M</vs-icon
              >
              Actual Account Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.actual_account_name }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.company_registration_number"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'company_registration_number',
                    'Company Registration Number'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Registration Number:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.company_registration_number }}
          </div>
        </div>
    
        <div class="vx-row mb-6" v-if="accountDescription.status">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'status',
                    'Status'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Company Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.status }}
          </div>
        </div>
                <div class="vx-row mb-6" v-if="accountDescription.company_category">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'company_category',
                    'Company Category'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Company Category:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.company_category }}
          </div>
        </div>
        <div v-if="accountDescription.registered_office_address_1 || accountDescription.registered_office_address_2 || accountDescription.registered_office_address_3 || accountDescription.registered_office_city || accountDescription.registered_office_county || accountDescription.registered_office_country || accountDescription.registered_office_country">
<vs-divider class="m-5" />
        <!-- Registered Office -->
        <h5 class="mb-5">Registered Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.registered_office_address_1"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'registered_office_address_1',
                    'Registered Office Address 1'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Address Line 1:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.registered_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.registered_office_address_2"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'registered_office_address_2',
                    'Registered Office Address 2'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.registered_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.registered_office_address_3"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'registered_office_address_3',
                    'Registered Office Address 3'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Address Line 3:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.registered_office_address_3 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.registered_office_city"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="showAccountMetaData('registered_office_city', 'Registered Office City')"
                size="small"
                >M</vs-icon
              >
              City:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.registered_office_city }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.registered_office_county"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData('registered_office_county', 'Registered Office County')
                "
                size="small"
                >M</vs-icon
              >
              County:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.registered_office_county }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.registered_office_postcode"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData('registered_office_postcode', 'Registered Office Postcode')
                "
                size="small"
                >M</vs-icon
              >
              Postcode:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.registered_office_postcode }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.registered_office_country"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData('registered_office_country', 'Registered Office Country')
                "
                size="small"
                >M</vs-icon
              >
              Country:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.registered_office_country }}
          </div>
        </div>

        <!-- Head Office -->
        <div v-if="accountDescription.head_office_address_1 || accountDescription.head_office_address_2 || accountDescription.head_office_address_3 || accountDescription.head_office_city || accountDescription.head_office_county || accountDescription.head_office_postcode || accountDescription.head_office_country">
                <vs-divider class="m-5" />
        <h5 class="mb-5">Head Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.head_office_address_1"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'head_office_address_1',
                    'Head Office Address 1'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Address Line 1:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.head_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.head_office_address_2"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'head_office_address_2',
                    'Head Office Address 2'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.head_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="accountDescription.head_office_address_3"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'head_office_address_3',
                    'Head Office Address 3'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Address Line 3:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.head_office_address_3 }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.head_office_city">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData('head_office_city', 'Head Office City')
                "
                size="small"
                >M</vs-icon
              >
              City:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.head_office_city }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.head_office_county">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              <vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'head_office_county',
                    'Head Office County'
                  )
                "
                size="small"
                >M</vs-icon
              >
              County:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.head_office_county }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.head_office_postcode">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="
                  showAccountMetaData(
                    'head_office_postcode',
                    'Head Office Postcode'
                  )
                "
                size="small"
                >M</vs-icon
              >
              Postcode:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.head_office_postcode }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.head_office_country">
    <div class="vx-col sm:w-1/5 w-full">
      <span>
        <vs-icon
          icon="loyalty"
          @click="
            showAccountMetaData(
              'head_office_country',
              'Head Office Country'
            )
          "
          size="small"
          >M</vs-icon
        >
        Country:
      </span>
    </div>
    <div class="vx-col sm:w-1/3 w-full">
      {{ accountDescription.head_office_country }}
    </div>
  </div>
        <!-- <vs-divider class="m-5" /> -->
        <template
          v-if="accountDescription.web && accountDescription.web.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
              <vs-icon
                icon="loyalty"
                @click="showWebMetaData('website', 'Websites')"
                size="small"
                >M</vs-icon
              >
              Company Website(s)
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="website_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + website_show_no + " entries" }}</span
            >
          </div>
          <div
            v-for="(website, web_key) in accountDescription.webShow"
            :key="web_key"
          >
            <span class="p-5">
              <p>{{ website.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <template
          v-if="
            accountDescription.linkedin &&
              accountDescription.linkedin.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
              <vs-icon
                icon="loyalty"
                @click="showLinkedinMetaData('linkedin', 'LinkedIn')"
                size="small"
                >M</vs-icon
              >
              Social Media Pages
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="linkedin_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + linkedin_show_no + " entries" }}</span
            >
          </div>
          <div
            v-for="(link, linkedin_key) in accountDescription.linkedinShow"
            :key="linkedin_key"
          >
            <span class="p-5">
              <p>{{ link.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <!-- Site Office -->
        <template
          v-if="
            accountDescription.satellite_office &&
              accountDescription.satellite_office.length > 0
          "
        >
          <h5 class="mb-5">Site Office Address</h5>
          <template
            v-for="(site, index) in accountDescription.satellite_office"
          >
            <div :key="index">
              <vs-divider class="m-5" />
              <h6 class="mb-5">{{ "Satellite Office " + (index + 1) }}</h6>
              <div class="vx-row mb-6" v-if="site.address_1">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    ><vs-icon
                      @click="
                        showSatelliteMetaData(
                          'address_1',
                          'Satellite Office Address 1'
                        )
                      "
                      icon="loyalty"
                      size="small"
                      >M</vs-icon
                    >
                    Address Line 1:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.address_1 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_2">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    ><vs-icon
                      @click="
                        showSatelliteMetaData(
                          'address_2',
                          'Satellite Office Address 2'
                        )
                      "
                      icon="loyalty"
                      size="small"
                      >M</vs-icon
                    >
                    Address Line 2:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.address_2 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_3">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    ><vs-icon
                      icon="loyalty"
                      @click="
                        showSatelliteMetaData(
                          'address_3',
                          'Satellite Office Address 3'
                        )
                      "
                      size="small"
                      >M</vs-icon
                    >
                    Address Line 3:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.address_3 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.city">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    ><vs-icon
                      icon="loyalty"
                      @click="
                        showSatelliteMetaData('city', 'Satellite Office City')
                      "
                      size="small"
                      >M</vs-icon
                    >
                    City:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.city }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.county">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    ><vs-icon
                      icon="loyalty"
                      @click="
                        showSatelliteMetaData(
                          'county',
                          'Satellite Office County'
                        )
                      "
                      size="small"
                      >M</vs-icon
                    >
                    County:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.county }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.postcode">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    ><vs-icon
                      icon="loyalty"
                      @click="
                        showSatelliteMetaData(
                          'postcode',
                          'Satellite Office Postcode'
                        )
                      "
                      size="small"
                      >M</vs-icon
                    >
                    Postcode:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.postcode }}</div>
              </div>
                <div class="vx-row mb-6" v-if="site.country">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    ><vs-icon
                      icon="loyalty"
                      @click="
                        showSatelliteMetaData(
                          'county',
                          'Satellite Office Country'
                        )
                      "
                      size="small"
                      >M</vs-icon
                    >
                    Country:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.country }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.phone.length != 0">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>
                    <vs-icon icon="loyalty" size="small">M</vs-icon>
                    Telephone:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <template v-for="(phone, key) in site.phone">
                    <div :key="key" v-if="phone.satellite_office_id == site.id">
                      {{ phone.phone_code }} - {{ phone.phone_no }}

                      <span v-if="phone.checked_status == 'Registered'" class="tps-registered" style="font-size:20px;" title="TPS Registered">®</span> 
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
                  <vs-divider class="m-5" />
        </template>

        <!-- Telephone -->
        <template
          v-if="accountDescription.phone && accountDescription.phone.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
              <vs-icon
                icon="loyalty"
                @click="showPhoneMetaData('phone', 'Phone')"
                size="small"
                >M</vs-icon
              >
              Telephone Number(s)
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="telephone_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + telephone_show_no + " entries" }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <template v-for="phone in accountDescription.phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <!-- <template v-if="p_type.type == 'head_office_switchboard'"> -->
                      <p class="m-10">

                        {{p_type.type}} : {{ phone.phone_code }}{{ phone.phone_no }} 
                        <span v-if="phone.checked_status == 'Registered'" class="tps-registered" style="font-size:20px;" title="TPS Registered">®</span> 

                      </p>
                    <!-- </template>
                    <template v-if="p_type.type == 'customer_service'">
                      <p class="m-10">
                        Customer Service - {{ phone.phone_no }}
                      </p>
                    </template>

                    <template v-if="p_type.type == 'sales_line'">
                      <p class="m-10">Sales Line - {{ phone.phone_no }}</p>
                    </template>

                    <template v-if="p_type.type == 'customer_support_line'">
                      <p class="m-10">
                        Customer Support Line - {{ phone.phone_no }}
                      </p>
                    </template> -->
                  </template>
                </template>
              </template>
            </div>
            <div class="vx-col sm:w-1/3 w-full"></div>
          </div>
        </template>
        <!-- SIC CODE -->
         <template
          v-if="accountDescription.sic_code && accountDescription.sic_code.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
              <vs-icon
                icon="loyalty"
                @click="showSicCodeMetaData('sic_code', 'Sic Code')"
                size="small"
                >M</vs-icon
              >
              Sic Code(s)
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="sic_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + sic_show_no + " entries" }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <template v-for="sic in accountDescription.sic_code">
                <p class="m-10" v-if="sic.sic_code_detail">
                  {{ sic.sic_code_detail.code }} {{ ' - ' +  sic.sic_code_detail.description }}
                </p>
              </template>
            </div>
            <div class="vx-col sm:w-1/3 w-full"></div>
          </div>
        </template>
        <template
          v-if="
            accountDescription.registration_jurisdiction ||
              accountDescription.parent ||
              accountDescription.vertical
          "
        >
          <h5 class="mb-5">Other Details</h5>
          <div
            class="vx-row mb-6"
            v-if="accountDescription.registration_jurisdiction"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                ><vs-icon
                  icon="loyalty"
                  @click="
                    showRegistrationJurisdictionMetaData(
                      'registration_jurisdiction',
                      'Registration Jurisdiction'
                    )
                  "
                  size="small"
                  >M</vs-icon
                >
                Registration Jurisdiction:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ RegistrationJurisdiction }}
              <!-- {{ accountDescription.registration_jurisdiction }} -->
            </div>
          </div>
          <div class="vx-row mb-6" v-if="accountDescription.parent">
            <div class="vx-col sm:w-1/5 w-full">
              <span
                ><vs-icon
                  icon="loyalty"
                  @click="showParentMetaData('parent', 'Parent')"
                  size="small"
                  >M</vs-icon
                >
                Parent Company:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ parent_name }}
            </div>
          </div>
          <div class="vx-row mb-6" v-if="accountDescription.vertical">
            <div class="vx-col sm:w-1/5 w-full">
              <span
                ><vs-icon
                  icon="loyalty"
                  @click="showVerticalMetaData('vertical', 'Vertical')"
                  size="small"
                  >M</vs-icon
                >
                Vertical:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- {{ accountDescription.vertical }} -->
              {{ verticalName }}
            </div>
          </div>
        </template>
        <div class="vx-row mb-6" v-if="accountDescription.revenue">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="showAccountMetaData('revenue', 'Revenue')"
                size="small"
                >M</vs-icon
              >
              Revenue:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.currency_name }} {{ accountDescription.revenue }}
          </div>
        </div>
          <div class="vx-row mb-6" v-if="accountDescription.no_of_employees">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
                icon="loyalty"
                @click="showAccountMetaData('no_of_employees', 'No of Employees')"
                size="small"
                >M</vs-icon
              >
              No of Employees:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.no_of_employees }} 
          </div>
        </div>
        <div class="vx-row mb-6" v-if="accountDescription.notes">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              ><vs-icon
              @click="showAccountMetaData('notes', 'Notes')"
                icon="loyalty"
                size="small"
                >M</vs-icon
              >
              Notes:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ accountDescription.notes }} 
          </div>
        </div>
        <h5 class="mb-5" v-if="groupCompanies.length > 0">
          Grouped Companies
        </h5>
        <Finder
          :theme="theme"
          style="cursor:pointer;"
          :key="componentKey"
          @expand="onExpand"
          :tree="companyTree"
        ></Finder>

        <!-- <div class="vx-row mb-6" v-if="groupCompanies.length > 0">
          <div class="vx-col sm:w-1/3 w-full">
            <template v-for="(company, key) in groupCompanies">
              <a target="blank" :key="key" :href="company.id"
                ><p class="mb-5">{{ company.company_name }}</p></a
              >
            </template>
          </div>
          <vs-divider class="m-5" />
        </div> -->
               
        <vs-row vs-w="12" class="mt-10">
          <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
            <template v-if="accountDescription.parent">
              <vs-button
                v-show="showGroupCompaniesButton"
                @click="showGroupCompanies"
                type="border"
                icon="search"
                color="danger"
                >Show Companies in this group</vs-button
              >
            </template>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="8"
            vs-sm="4"
            vs-xs="12"
          >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
          
          </vs-col>
        </vs-row>
      </vx-card>
    </div>
    <vs-popup :title="'Meta Data - ' + metaTitle" :active.sync="popupActive">
      <vx-timeline :data="metadata" />
    </vs-popup>
    <vs-popup
      class="text-center"
      fullscreen
      :title="
        'Meta Data - ' +
          accountDescription.company_name
      "
      :active.sync="satellitePopupActive"
    >
      <div :key="key" v-for="(value, key) in satelliteOfficeHistoryData">
        <vs-table stripe :data="value">
          <template slot="thead">
            <vs-th>
              Updated On
            </vs-th>
            <vs-th>
              Address 1
            </vs-th>
            <vs-th>
              Address 2
            </vs-th>
            <vs-th>
              Address 3
            </vs-th>
            <vs-th>
              City
            </vs-th>
            <vs-th>
              County
            </vs-th>
            <vs-th>
              Postcode
            </vs-th>
            <vs-th>
              Country
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].updated_at">
                {{ convertTime(data[indextr].updated_at) }}
              </vs-td>
              <vs-td :data="data[indextr].address_1">
                  {{data[indextr].address_1}}
              </vs-td>
              <vs-td :data="data[indextr].address_2">
              
               {{data[indextr].address_2}}
               
              </vs-td>
              <vs-td :data="data[indextr].address_3">
               
               {{data[indextr].address_3}}
               
              </vs-td>
              <vs-td :data="data[indextr].city">
               
              {{data[indextr].city}}
              
              </vs-td>
              <vs-td :data="data[indextr].county">

                 {{data[indextr].county}}
               
              </vs-td>
              <vs-td :data="data[indextr].postcode">
            {{data[indextr].postcode}}
              </vs-td>
              <vs-td :data="data[indextr].country">
              
                  {{ data[indextr].country }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-divider class="p-5" />
      </div>
    </vs-popup>
    <vs-popup
      fullscreen
      class="text-center"
      :title="'Meta Data - ' + metaTitle"
      :active.sync="MasterPopupActive"
    >
      <vs-table stripe :data="masterMetadata">
        <template slot="thead">
          <vs-th>
            Updated On
          </vs-th>
          <vs-th>
            User
          </vs-th>
          <vs-th>
            Authorized User
          </vs-th>
          <vs-th>
            Is Sole Trader
          </vs-th>
          <vs-th>
            Source
          </vs-th>
          <vs-th>
            Company Name
          </vs-th>
          <vs-th>
            Registration No.
          </vs-th>
          <vs-th>
            Head Office Country
          </vs-th>
          <vs-th>
            Registered Office Address 1
          </vs-th>
          <vs-th>
            Registered Office Address 2
          </vs-th>
          <vs-th>
            Registered Office Address 3
          </vs-th>
          <vs-th>
            Registered Office City
          </vs-th>
          <vs-th>
            Registered Office County
          </vs-th>
          <vs-th>
            Registered Office Postcode
          </vs-th>
          <vs-th>
            Registered Office Country
          </vs-th>
          <vs-th>
            Head Office Address 1
          </vs-th>
          <vs-th>
            Head Office Address 2
          </vs-th>
          <vs-th>
            Head Office Address 3
          </vs-th>
          <vs-th>
            Head Office City
          </vs-th>
          <vs-th>
            Head Office County
          </vs-th>
          <vs-th>
            Head Office Postcode
          </vs-th>
          <vs-th>
            Registration Jurisdiction
          </vs-th>
          <vs-th>
            Parent
          </vs-th>
          <vs-th>
            Vertical
          </vs-th>
          <vs-th>
            Website
          </vs-th>
          <vs-th>
            Social Media
          </vs-th>
          <vs-th>
            Phone
          </vs-th>
          <vs-th>
            Satellite Office
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id" style="display:none;">
              {{ (provious_index = indextr != 0 ? indextr - 1 : indextr) }}
            </vs-td>
            

            <vs-td :data="data[indextr].updated_at">
              {{ convertTime(data[indextr].updated_at) }}
            </vs-td>

            <vs-td :data="data[indextr].user_detail">
              {{ data[indextr].user_detail.first_name }}  {{ data[indextr].user_detail.surname }}
            </vs-td>
            <vs-td :data="data[indextr].user_detail">
              {{ data[indextr].user_detail.first_name }}  {{ data[indextr].user_detail.surname }}
            </vs-td>
            <vs-td :data="data[indextr].is_sole_trader">
              <template
                v-if="
                  data[indextr].is_sole_trader !=
                    data[provious_index].is_sole_trader
                "
              >
                <u>{{data[indextr].is_sole_trader}}</u>
              </template>
              <template v-else>
                {{ data[indextr].is_sole_trader }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].source">
              <template
                v-if="
                  data[indextr].source !=
                    data[provious_index].source
                "
              >
                <u>{{data[indextr].source}}</u>
              </template>
              <template v-else>
                {{ data[indextr].source }}
              </template>
            </vs-td>

            <vs-td :data="data[indextr].company_name">
              <template
                v-if="
                  data[indextr].company_name !=
                    data[provious_index].company_name
                "
              >
                <u>{{data[indextr].company_name}}</u>
              </template>
              <template v-else>
                {{ data[indextr].company_name }}
              </template>
            </vs-td>

            <vs-td :data="data[indextr].company_registration_number">
              <template
                v-if="
                  data[indextr].company_registration_number !=
                    data[provious_index].company_registration_number
                "
              >
               <u> {{data[indextr].company_registration_number}}</u>
              </template>
              <template v-else>
                {{ data[indextr].company_registration_number }}
              </template>
            </vs-td>

            <vs-td :data="data[indextr].head_office_country">
              <template
                v-if="
                  data[indextr].head_office_country !=
                    data[provious_index].head_office_country
                "
              >
          <u>
{{data[indextr].head_office_country}}          </u>
              </template>
              <template v-else>
                {{ data[indextr].head_office_country }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registered_office_address_1">
              <template
                v-if="
                  data[indextr].registered_office_address_1 !=
                    data[provious_index].registered_office_address_1
                "
              >
            <u>
              {{data[indextr].registered_office_address_1}}
            </u>
              </template>
              <template v-else>
                {{ data[indextr].registered_office_address_1 }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registered_office_address_2">
              <template
                v-if="
                  data[indextr].registered_office_address_2 !=
                    data[provious_index].registered_office_address_2
                "
              >
<u>
  {{data[indextr].registered_office_address_2}}
</u>

              </template>
              <template v-else>
                {{ data[indextr].registered_office_address_2 }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registered_office_address_3">
              <template
                v-if="
                  data[indextr].registered_office_address_3 !=
                    data[provious_index].registered_office_address_3
                "
              >
              <u>
{{data[indextr].registered_office_address_3}}
              </u>
              
              </template>
              <template v-else>
                {{ data[indextr].registered_office_address_3 }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registered_office_city">
              <template
                v-if="
                  data[indextr].registered_office_city !=
                    data[provious_index].registered_office_city
                "
              >
              <u>{{data[indextr].registered_office_city}}</u>
              </template>
              <template v-else>
                {{ data[indextr].registered_office_city }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registered_office_county">
              <template
                v-if="
                  data[indextr].registered_office_county !=
                    data[provious_index].registered_office_county
                "
              >
              <u>
{{data[indextr].registered_office_county}}</u>
              </template>
              <template v-else>
                {{ data[indextr].registered_office_county }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registered_office_postcode">
              <template
                v-if="
                  data[indextr].registered_office_postcode !=
                    data[provious_index].registered_office_postcode
                "
              >
              <u>{{data[indextr].registered_office_postcode}}</u>
              </template>
              <template v-else>
                {{ data[indextr].registered_office_postcode }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registered_office_country">
              <template
                v-if="
                  data[indextr].registered_office_country !=
                    data[provious_index].registered_office_country
                "
              >
                <u>
                {{ data[indextr].registered_office_country }}
                </u>
              </template>
              <template v-else>
                {{ data[indextr].registered_office_country }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].head_office_address_1">
              <template
                v-if="
                  data[indextr].head_office_address_1 !=
                    data[provious_index].head_office_address_1
                "
              >
                <u>{{data[indextr].head_office_address_1}}</u>
              </template>
              <template v-else>
                {{ data[indextr].head_office_address_1 }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].head_office_address_2">
              <template
                v-if="
                  data[indextr].head_office_address_2 !=
                    data[provious_index].head_office_address_2
                "
              >
              <u>{{data[indextr].head_office_address_2}}</u>
              </template>
              <template v-else>
                {{ data[indextr].head_office_address_2 }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].head_office_address_3">
              <template
                v-if="
                  data[indextr].head_office_address_3 !=
                    data[provious_index].head_office_address_3
                "
              >
              <u>{{data[indextr].head_office_address_3}}</u>
              </template>
              <template v-else>
                {{ data[indextr].head_office_address_3 }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].head_office_city">
              <template
                v-if="
                  data[indextr].head_office_city !=
                    data[provious_index].head_office_city
                "
              >
            <u>  {{data[indextr].head_office_city}}</u>
              </template>
              <template v-else>
                {{ data[indextr].head_office_city }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].head_office_county">
              <template
                v-if="
                  data[indextr].head_office_county !=
                    data[provious_index].head_office_county
                "
              >
              <u>
{{data[indextr].head_office_county}}</u>
              </template>
              <template v-else>
                {{ data[indextr].head_office_county }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].head_office_postcode">
              <template
                v-if="
                  data[indextr].head_office_postcode !=
                    data[provious_index].head_office_postcode
                "
              >
              <u>{{data[indextr].head_office_postcode}}</u>
              </template>
              <template v-else>
                {{ data[indextr].head_office_postcode }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].registration_jurisdiction">
              <template
                v-if="
                  data[indextr].registration_jurification_name !=
                    data[provious_index].registration_jurification_name
                "
              >
         <u>     {{data[indextr].registration_jurification_name}} </u>

              </template>
              <template v-else>
                {{ data[indextr].registration_jurification_name }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].parent">
              <template
                v-if="data[indextr].parent != data[provious_index].parent"
              >
<u>{{data[indextr].parental_name}}</u>
              </template>
              <template v-else>
                {{ data[indextr].parental_name }}
              </template>
            </vs-td>
            <vs-td :data="data[indextr].vertical">
              <template
                v-if="data[indextr].vertical != data[provious_index].vertical"
              >
              {{data[indextr].vertical_name}}
              </template>
              <template v-else>
                {{ data[indextr].vertical_name }}
              </template>
            </vs-td>
            <vs-td>
              <vs-button
                icon="visibility"
                color="grey"
                size="small"
                @click="showWebMetaData('website', 'Websites')"
              >Show</vs-button>
            </vs-td>
            <vs-td>
              <vs-button
                icon="visibility"
                color="grey"
                size="small"
                @click="showLinkedinMetaData('linkedin', 'LinkedIn')"
              >Show</vs-button>
            </vs-td>
            <vs-td>
              <vs-button
                icon="visibility"
                color="grey"
                size="small"
                @click="showPhoneMetaData('phone', 'Phone')"
              >Show</vs-button>
            </vs-td>
            <vs-td>
                <vs-button
                  :key="index"
                  icon="visibility"
                  color="grey"
                  size="small"
                  @click="showSatelliteOffice()"
                >
                  Show</vs-button
                >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities.js'
import _ from "lodash";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import vSelect from "vue-select";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import VxTimeline from "@/components/timeline/VxTimeline";
import { Finder } from "@jledentu/vue-finder";
import "@jledentu/vue-finder/dist/vue-finder.css";
export default {
  data() {
    return {
                              abilities : null,

      satelliteOffices: [],
      showGroupCompaniesButton: true,
      componentKey: 0,
      satellitePopupActive: false,
      satelliteOfficeHistoryData: [],
      satelliteMetaTitle: null,
      satelliteMetadataName: null,
      masterMetadata: [],
      accountDescription: [],
      telephone_show_no: 5,
      sic_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      groupCompanies: [],
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      popupActive: false,
      MasterPopupActive: false,
      metadataName: null,
      metadata: [],
      metaTitle: null,
      companyTree: {},
      theme: {
        primaryColor: "rgba(255, 0, 0, 0.52)",
        arrowColor: "black",
        separatorColor: "#ccc",
        separatorWidth: "1px",
        dropZoneBgColor: "rgba(33, 150, 243, 0.2)",
        draggedItemBgColor: "rgba(33, 150, 243, 0.5)"
      }
    };
  },
  components: {
    "v-select": vSelect,
    AccountAutocomplete,
    VxTimeline,
    Finder
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    this.init();
  },
  watch: {
    website_show_no(val) {
      if (val) {
        this.accountDescription.webShow = this.accountDescription.web.slice(
          0,
          val
        );
      }
    },
    linkedin_show_no(val) {
      if (val) {
        this.accountDescription.linkedinShow = this.accountDescription.linkedin.slice(
          0,
          val
        );
      }
    },
    telephone_show_no(val) {
      if (val) {
        this.accountDescription.phone = this.accountDescription.phone.slice(
          0,
          val
        );
      }
    },
    sic_show_no(val) {
      if (val) {
        this.accountDescription.sic_code = this.accountDescription.sic_code.slice(
          0,
          val
        );
      }
    }
  },
  mounted() {},
  methods: {
    init() {
      const accountId = this.$route.params.accountId;
      this.$store
        .dispatch("accountsManagement/fetchAccount", accountId)
        .then(res => {
          this.accountDescription = res.data;


          this.accountDescription.webShow = this.accountDescription.web.slice(
            0,
            this.website_show_no
          );
          this.accountDescription.linkedinShow = this.accountDescription.linkedin.slice(
            0,
            this.linkedin_show_no
          );
          this.accountDescription.phone = this.accountDescription.phone.slice(
            0,
            this.telephone_show_no
          );
          this.accountDescription.sic_code = this.accountDescription.sic_code.slice(
            0,
            this.sic_show_no
          );
          if (this.accountDescription.parent) {
            this.showParentName(this.accountDescription.parent);
          }
          if (this.accountDescription.registration_jurisdiction) {
            this.showRegistrationJurisdiction(
              this.accountDescription.registration_jurisdiction
            );
          }
          if (this.accountDescription.vertical) {
            this.showVertical(this.accountDescription.vertical);
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription = true;
            return;
          }
          console.error(err);
        });
    },
    onExpand({ expanded, sourceEvent }) {
      if (sourceEvent == "click") {
        if (expanded.length > 2) {
          let accountId = expanded[2];
          window.location.href = `/accounts/${accountId}`;
        }
      }
    },
    goBack: function() {
      this.$router.push({ path: `/accounts` });
    },
    editCompany() {
      // this.$router.replace("edit/" + this.accountDescription.id);
      let accountId = this.accountDescription.id;
      this.$router.push({ path: `edit/${accountId}` });
    },
    showAccountMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getAccountsMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;

       

          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {


            var propName = ele[columnName];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showWebMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getWebMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;
          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {
            var propName = ele["url"];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showLinkedinMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getLinkedinMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;
          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {
            var propName = ele["url"];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showPhoneMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getPhoneMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;
          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {
            var propName = ele["phone_no"];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdictionMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getRegistrationJurisdictionMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;
          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {
            var propName = ele['registration_jurisdiction_name'];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showParentMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getParentMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;
          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {
            var propName = ele['parent_name'];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showVerticalMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getVerticalMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;
          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {
            var propName = ele['vertical_name'];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showSicCodeMetaData(columnName, columnTitle) {
      this.popupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getSicCodeMetaData",
          this.accountDescription.id
        )
        .then(res => {
          this.metadata = res.data;
          this.metadataName = columnName;
          this.metaTitle = columnTitle;
          this.metadata = this.metadata.map(ele => {
            var propName = ele['sic_code_detail']["code"] + ' - ' +  ele['sic_code_detail']["description"];
            if (ele.operation_type == 0) {
              ele.color = "success";
              ele.icon = "PlusIcon";
              ele.title = "Created " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else if (ele.operation_type == 1) {
              ele.icon = "EditIcon";
              ele.color = "success";
              ele.title = "Modified to  " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            } else {
              ele.icon = "RemoveIcon";
              ele.color = "success";
              ele.title = "Deleted " + propName;
              ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
              ele.time = this.convertTime(ele.updated_at);
            }
            return ele;
          });
          this.metadata = this.metadata.filter(
            (thing, index, self) =>
              index ===
              self.findIndex(
                t => t.title == thing.title && t.icon == thing.icon
              )
          );
          return;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.metadata = true;
            return;
          }
          console.error(err);
        });
    },
    showSatelliteOffice() {
      // console.log(this.satelliteOffices);
      // const keysSorted = Object.keys(this.satelliteOffices).sort(function(a,b){return b-a})
      var sat = this.satelliteOffices
      var ordered = {};   
      _(sat).keys().sort().each(function (key) {
        ordered[key] = sat[key];
      });
      this.satelliteOfficeHistoryData = ordered;
      // var result = _.pickBy(this.satelliteOffices, function(value, key) {
      //   return _.startsWith(key, id);
      // });
      // console.log(result[id])
      // this.satelliteOfficeHistoryData = result[id];
      this.satellitePopupActive = true;
      // console.log(result)
      // console.log(Object.filter(this.satelliteOffices, [id], true))
      // console.log(typeof this.satelliteOffices);
      // this.satelliteOfficeHistoryData = this.satelliteOffices.filter(ele => {
      //   console.log(ele)
      // })
    },
    showSatelliteMetaData(columnName, columnTitle) {
      if (columnName == "masterSatellite") {
        this.satellitePopupActive = true;
      } else {
        this.popupActive = true;
      }

      this.$store
        .dispatch(
          "accountsManagement/getSatelliteOfficeMetaData",
          this.accountDescription.id
        )
        .then(res => {
          if (columnName == "masterSatellite") {
            this.satelliteMetadataName = columnName;
            this.satelliteMetaTitle = columnTitle;
            this.satelliteOfficeHistoryData = res.data;
            let satelliteOfficeHistoryData = res.data;
            this.satelliteOffices = satelliteOfficeHistoryData.reduce(
              (res, curr) => {
                if (res[curr.transaction_id])
                  res[curr.transaction_id].push(curr);
                else Object.assign(res, { [curr.transaction_id]: [curr] });

                return res;
              },
              {}
            );
          } else {
            this.metadata = res.data;
            this.metadataName = columnName;
            this.metaTitle = columnTitle;
            this.metadata = this.metadata.map(ele => {
              var propName = ele[columnName];
              if (ele.operation_type == 0) {
                ele.color = "success";
                ele.icon = "PlusIcon";
                ele.title = "Created " + propName;
                ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
                ele.time = this.convertTime(ele.updated_at);
              } else if (ele.operation_type == 1) {
                ele.icon = "EditIcon";
                ele.color = "success";
                ele.title = "Modified to  " + propName;
                ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
                ele.time = this.convertTime(ele.updated_at);
              } else {
                ele.icon = "RemoveIcon";
                ele.color = "success";
                ele.title = "Deleted " + propName;
                ele.user = ele.user_detail.first_name + ' ' + ele.user_detail.surname;
                ele.time = this.convertTime(ele.updated_at);
              }
              return ele;
            });
            this.metadata = this.metadata.filter(
              (thing, index, self) =>
                index ===
                self.findIndex(
                  t => t.title == thing.title && t.icon == thing.icon
                )
            );
            return;
          }
        })
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.metadata = [];
          //   return;
          // }
          console.error(err);
        });
    },
    getSatellite() {
      this.$store
        .dispatch(
          "accountsManagement/getSatelliteOfficeMetaData",
          this.accountDescription.id
        )
        .then(res => {
          var result = res.data;
          this.satelliteOffices = result.reduce((res, curr) => {
            if (res[curr.transaction_id]) res[curr.transaction_id].push(curr);
            else Object.assign(res, { [curr.transaction_id]: [curr] });

            return res;
          }, {});
        })
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.metadata = [];
          //   return;
          // }
          console.error(err);
        });
    },
    showMasterMetaData() {
      this.popupActive = false;
      this.MasterPopupActive = true;
      this.$store
        .dispatch(
          "accountsManagement/getMasterMetaData",
          this.$route.params.accountId
        )
        .then(res => {
          if (res.data) {
            this.masterMetadata = res.data;
            this.masterMetadata.map(ele => {
              if (ele.parent) {
                this.getParentName(ele.parent).then(function(parental) {
                  ele.parental_name = parental.company_name;
                });
              } else {
                ele.parental_name = "";
              }

              if (ele.registration_jurisdiction) {
                this.getRegistrationJurificationName(
                  ele.registration_jurisdiction
                ).then(function(registration_jurification) {
                  ele.registration_jurification_name =
                    registration_jurification.name_1;
                });
              } else {
                ele.registration_jurification_name = "";
              }

              if (ele.vertical) {
                this.getVerticalName(ele.vertical).then(function(
                  vertical_name
                ) {
                  ele.vertical_name = vertical_name.vertical;
                });
              } else {
                ele.vertical_name = "";
              }
              return ele;
            });
            this.metaTitle = this.accountDescription.company_name;
            this.getSatellite();
            return;
          }
        })
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.masterMetadata = [];
          //   return;
          // }
          console.error(err);
        });
    },
    showMasterSatelliteOffice() {
      this.popupActive = false;
      this.satellitePopupActive = true;
      // this.showSatelliteMetaData("masterSatellite", "Satellite Office");
    },
    convertTime(apiTime) {
      // date = Date.parse(apiTime)
      let date = new Date(apiTime);
      return date.toLocaleString();
    },
    showGroupCompanies() {
      const parentId = this.accountDescription.parent;
      this.$store
        .dispatch("accountsManagement/getGroupCompanies", parentId)
        .then(res => {
          this.groupCompanies = JSON.parse(
            JSON.parse(JSON.stringify(res.data))
          );
          this.groupCompanies = this.groupCompanies.map(ele => {
            ele.id = ele.children_id;
            ele.label = ele.children_name;
            return ele;
          });
          this.companyTree = {
            id: "root",
            children: [
              {
                id: "companies",
                label: this.parent_name,
                children: this.groupCompanies
              }
            ]
          };
          return;
        })
        .catch(err => {
          if (err.status === 404) {
            this.groupCompanies = [];
            return;
          }
          console.error(err);
        });
      this.showGroupCompaniesButton = false;
    },
    getRegistrationJurificationName(countryId) {
      return this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => res.data)
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.accountDescription.res = true;
          //   return;
          // }
          console.error(err);
        });
    },
    getParentName(parentId) {
      return this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => res.data)
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    showParentName(parentId) {
      this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => {
          this.parent_name = res.data.company_name;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    getVerticalName(verticalId) {
      return this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => res.data)
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.verticalName = true;
          //   return;
          // }
          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => {
          this.verticalName = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 80px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */

</style>
